import React from "react";

const RadioItem = ({ menuName, checked, onYes, onNo, icon, isDisabled }) => {
  return (
    <div className="group-input" title={isDisabled ? "Always active" : ""}>
      <div className="group-label">
        {icon && (
          <img src={icon} className="community-tab-icon" alt={menuName}></img>
        )}
        {menuName}
      </div>
      <div className="radio-container">
        <div>
          <input
            type="radio"
            value="yes"
            checked={checked}
            onChange={onYes}
            disabled={isDisabled}
          />
          <label>Yes</label>
        </div>
        <div>
          <input
            type="radio"
            value="no"
            checked={!checked}
            onChange={onNo}
            disabled={isDisabled}
          />
          <label>No</label>
        </div>
      </div>
    </div>
  );
};
export default RadioItem;



// WEBPACK FOOTER //
// ./src/components/RadioItem.js